<main class="card">
  <div class="brand">
    <span class="brand__mark"><mng-icon name="package" /></span>
    <span class="brand__text">
      <span class="brand__name">Canvas Builder</span>
      <span class="brand__sub">Management</span>
    </span>
  </div>
  <h1>{{ copy().heading }}</h1>
  <p>{{ copy().body }}</p>
  <div class="actions">
    @switch (reason()) {
      @case ('unavailable') {
        <button type="button" class="primary" (click)="reload()">Reload</button>
      }
      @case ('signed-out') {
        <button type="button" class="primary" (click)="auth.signIn()">
          Sign in
        </button>
      }
      @default {
        <button type="button" class="primary" (click)="auth.logout()">
          Sign out
        </button>
      }
    }
  </div>
</main>
